export default {
  signup: {
    left: {
      header: {
        feature: "Welcome to Dataships",
        heading: "Get started for free in 5 minutes",
        description:
          "Grow your email lists by optimizing your marketing compliance at the checkout.",
      },
      getStarted: {
        title:
          "Before you begin, kindly make sure you have the following list:",
        item1: "Klaviyo access to create a private API key",
        item2: "The URL of your current privacy policy",
        item3: "Access to your Shopify store to edit Checkout settings",
      },
    },
    right: {
      header: {
        feature: "Sign up",
        heading: "Create your account",
      },
    },
  },
} as const;
